import { ApplicationsStore } from "@/services/stores/types";
import { StateCreator } from "zustand";

export const applicationsStore: StateCreator<ApplicationsStore> = set => ({
  applications: null,
  activeApplication: null,
  setApplications: applications =>
    set(() => ({
      applications,
      activeApplication: applications?.[0],
    })),
  setActiveApplication: activeApplication =>
    set(state => ({
      ...state,
      activeApplication,
    })),
  resetApplications: () =>
    set(state => {
      return {
        ...state,
        applications: null,
        activeApplication: null,
      };
    }),
});
